import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import FmStorageTableService from 'app/admin/fileManager/service/FmStorageTableService';

const config = {
	key: 'fmStorageTable',
	text: 'Megosztott mappák',
	textKey: 'fm-storage',
	service: FmStorageTableService,
	editFormState: item => `/fm-storage/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowEndAction: ['subPage', 'modify'],
	rowClick: item => `/fm-browser/0/${item.id}`,
	subPage: {
		state: '/fm-browser/0/',
		tooltip: 'Tartalom'
	},
	columns: [
		{
			key: 'fileCategory',
			text: '',
			textKey: 'fileCategory',
			type: 'iconFileType',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'fileName',
			text: 'Név',
			textKey: 'fileName',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'fileModified',
			text: 'Módosítva',
			textKey: 'fileModified',
			type: 'dateTime',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'fileSize',
			text: 'Méret',
			textKey: 'fileSize',
			type: 'fileSize',
			sortable: true,
			disablePadding: false
		}
	]
};

function FmStorageTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('fmStorageTable', reducer('fmStorageTable'))(FmStorageTable);
